


























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { FormattedConfiguration } from '../utils/types'

@Component
export default class ConfigurationCrud extends Vue {
  @Prop(Object) configuration?: FormattedConfiguration
  @Prop(String) valueType?: string;
  data: FormattedConfiguration = this.configPropData
  isLoading = false

  @Watch('configuration')
  onConfigPropChange () {
    this.data = this.configPropData
  }

  emitClose () {
    this.$emit('close')
  }

  async emitSubmit () {
    this.$emit('submit', { key: this.data?.key, value: this.data?.value.toString() })
  }

  get configPropData () {
    return {
      id: this.configuration?.id ?? '',
      key: this.configuration?.key ?? '',
      value: this.configuration?.value ?? '',
      hebrewKey: this.configuration?.hebrewKey ?? ''
    }
  }
}
